import "@/App.css";
import React from "react";
import { AppProvider, useApp } from "@/context/AppContext";
import { BrandProvider } from "@/context/BrandContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import ClientView from "@/pages/ClientView";
import UsineView from "@/pages/UsineView";
import TransporteurView from "@/pages/TransporteurView";
import AdminView from "@/pages/AdminView";
import { StaffLogin } from "@/components/StaffLogin";
import { Toaster } from "@/components/ui/sonner";

const STAFF_ROLES = ["usine", "transporteur", "admin"];

const Router = () => {
  const { role, staffToken } = useApp();
  if (STAFF_ROLES.includes(role) && !staffToken) {
    return (
      <main className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6">
        <StaffLogin />
      </main>
    );
  }
  return (
    <main className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6">
      {role === "client" && <ClientView />}
      {role === "usine" && <UsineView />}
      {role === "transporteur" && <TransporteurView />}
      {role === "admin" && <AdminView />}
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrandProvider>
        <AppProvider>
          <Header />
          <Router />
          <Footer />
          <Toaster position="bottom-center" richColors />
        </AppProvider>
      </BrandProvider>
    </div>
  );
}

export default App;
